import * as Factory from 'factory.ts'
import faker from 'faker'

import { PrimaryCategoryApiModelStub } from './PrimaryCategoryApiModel.stub'
import { type DepartmentApiModel } from '../DepartmentApiModel'

export const SecondaryCategoryApiModelStub =
  Factory.Sync.makeFactory<DepartmentApiModel>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    active: true,
    branch: Factory.each(() => PrimaryCategoryApiModelStub.build()),
  })
